import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Icon } from '~/components/atomic';
import CreatorTag from '../../CharacterCard/CreatorTag/CreatorTag';

interface GameCardInfoProps {
  title: string;
  liked_count: number;
  create_username: string;
  handlePlayGameClick?: (() => void) | null;
}

export default function GameCardInfo({
  title,
  liked_count,
  create_username,
  handlePlayGameClick = null,
}: GameCardInfoProps) {
  const isMissionGameCard = !!handlePlayGameClick;
  return (
    <GameCardInfoBlurBox>
      <GameInfoContainer isMissionGameCard={isMissionGameCard}>
        <CreatorTag create_username={create_username} />
        <Title>{title}</Title>

        <GameLikeCount>
          <Icon
            size={20}
            iconName={'Favorite'}
            style={{ width: 'fit-content' }}
          />
          {liked_count}
        </GameLikeCount>
      </GameInfoContainer>

      {isMissionGameCard && (
        <GamePlayButton
          onClick={(e) => {
            e.stopPropagation();
            handlePlayGameClick();
          }}
        >
          <Icon iconName='Play' size={23} style={{ color: 'black' }} />
        </GamePlayButton>
      )}
    </GameCardInfoBlurBox>
  );
}

export const GameCardInfoBlurBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: absolute;
    bottom: 0;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 92px;
    padding: 0 15px;
    background: ${theme.backgroundColor.bg_dark_4_alpha};
    backdrop-filter: blur(4px);
  `}
`;

const GameInfoContainer = styled.div<{ isMissionGameCard: boolean }>`
  ${({ isMissionGameCard }) => css`
    display: flex;
    gap: 4px;
    flex-direction: column;
    max-width: ${isMissionGameCard ? '130px' : '180px'};
  `}
`;

const Title = styled.h3`
  ${({ theme }) => css`
    display: block;
    ${theme.mixins.text.ellipsis_1};
    width: 100%;
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body16_medium};
  `}
`;

const GameLikeCount = styled.div`
  display: flex;
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    width: 100%;
    color: ${theme.content.content_light_3};
    ${theme.fontStyle.text.caption_medium};
  `}
`;

const GamePlayButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-height: 32px;
  border-radius: 999px;
  background-color: white;
`;
